// Drop-in replacement for Math.random() backed by a cryptographic RNG.
// Returns a float in [0, 1), same range/shape as Math.random().
export const secureRandom = (): number => {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] / (0xffffffff + 1);
};
